import { RDLivestock } from '@cibo/core'
import { useFigures } from '@cibo/ui'
import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { DetailPanel } from '../DetailPanel'
import { LivestockPanelTable } from './LivestockPanelTable'

export const LivestockPanel = () => {
  const { t } = useTranslation('@cibo/landmanager/LivestockPanel')
  const { livestockSpecies } = useFigures()

  return (
    <DetailPanel<RDLivestock>
      title={t('livestock')}
      traitId="livestock"
      DetailTable={LivestockPanelTable}
      DetailIndividual={({ currentYearData }: { currentYearData?: RDLivestock }) => (
        <Stack>
          {currentYearData?.result === undefined ? (
            <Typography variant="subtitle1">--</Typography>
          ) : (
            <>
              <Typography variant="subtitle1">
                {currentYearData?.input?.species === undefined
                  ? //@ts-ignore definitely not undefined
                    t('none')
                  : livestockSpecies(currentYearData?.input?.species)}
              </Typography>
              {!!currentYearData?.input &&
                !!currentYearData?.input.headcount &&
                currentYearData.input.daysGrazing > 0 && (
                  <Typography variant="caption">
                    {t('headDays', {
                      count: currentYearData.input.daysGrazing,
                      days: currentYearData.input.daysGrazing,
                      head: currentYearData.input.headcount,
                    })}
                  </Typography>
                )}
            </>
          )}
        </Stack>
      )}
    />
  )
}
